import React from 'react';
import block from 'bem-cn-lite';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

import './UnpublishedLabel.scss';

const b = block('UnpublishedLabel');

export type LabeLType = 'label' | 'line';

export interface UnpublishedLabelProps extends WithTranslationProps {
    type?: LabeLType;
    className?: string;
}

const UnpublishedLabel: React.FC<UnpublishedLabelProps> = ({
    className,
    children,
    type = 'line',
    i18nK,
}) => <div className={b({type}, className)}>{children || i18nK('label_non_published')}</div>;

export default withTranslation()(UnpublishedLabel);
